import codes from "../../../errorCodes/Tenant"

export default function tenantErrorHandler(errorCode: string) {
  switch (errorCode) {
    case codes.TenantNotFoundErr:
      return "errors.PBIDETenantNotFound"
    case codes.TenantNotActive:
      return "errors.PBIDETenantNotActive"
    case codes.SubdomainNotFound:
      return "errors.PBIDESubdomainNotFound"
    case codes.SubdomainAlreadyExists:
      return "errors.PBIDESubdomainAlreadyExists"
    case codes.SubdomainCannotBeChanged:
      return "errors.PBIDESubdomainCannotBeChanged"
    case codes.SubdomainTooShort:
      return "errors.PBIDESubdomainTooShort"
    case codes.SubdomainTooLong:
      return "errors.PBIDESubdomainTooLong"
    case codes.SubdomainInvalid:
      return "errors.PBIDESubdomainInvalid"
    case codes.PublicNameAlreadyExists:
      return "errors.PBIDEPublicNameAlreadyExists"
    case codes.PublicNameTooShort:
      return "errors.PBIDEPublicNameTooShort"
    case codes.PublicNameTooLong:
      return "errors.PBIDEPublicNameTooLong"
    case codes.PublicNameInvalid:
      return "errors.PBIDEPublicNameInvalid"
    case codes.TenantCannotBeChanged:
      return "errors.PBIDETenantCannotBeChanged"
    case codes.LocaleInvalid:
      return "errors.PBIDELocaleInvalid"
    default:
      return ""
  }
}
